import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {GeneralFilter} from '@app/shared';
import {ScreenService} from '@app/core';
import {AdministrationUtilsService} from '../../features/administration/services/administration-utils.service';

@Component({
  selector: 'app-layout-main',
  standalone: false,

  templateUrl: './layout-main.component.html',
  styleUrl: './layout-main.component.less'
})
export class LayoutMainComponent implements OnInit {
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() color: string = '';
  @Input() bgColor: string = '';
  @Input() adjustPaddingBot: boolean = false;
  @Input() filters: GeneralFilter[] = []; // Filtros generales
  @Input() primaryBtnLabel: string = '';
  @Input() showSearchBar: boolean = true;
  @Input() isNotification: boolean = false;
  @Input() showMobileSearchBar: boolean = true;
  @Input() fullWidth: boolean = false;
  @Input() hideFilters: boolean = false;
  @Output() filterEvent = new EventEmitter<{ code: string, searchValue: string }>();
  @Output() primaryBtnEvent = new EventEmitter<void>();

  isMobile$;
  hideSearch = true;
  searchValue = '';
  hideGlobalSearch: boolean = true;

  isAdministrationView: boolean = false;

  constructor(
    private screenService: ScreenService,
    public administrationUtilsService: AdministrationUtilsService,
    private router: Router
  ) {
    this.isMobile$ = screenService.isMobile$;
  }

  ngOnInit() {
    this.isAdministrationView = window.location.href.includes('/administration');
  }

  // Quizas la logica de filtrado sea mejor en un servicio
  onFilterSelect(filter: GeneralFilter) {
    this.filters.forEach(f => (f.active = false));
    filter.active = true;
    this.filterEvent.emit({code: filter.code || '', searchValue: this.searchValue});
  }

  toggleSearch(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.hideGlobalSearch = true;
    this.hideSearch = !this.hideSearch;
  }

  toggleGlobalSearch(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.hideSearch = true;
    this.hideGlobalSearch = !this.hideGlobalSearch;
  }

  emitPrimaryBtnEvent(): void {
    this.primaryBtnEvent.emit();
  }


  emitSearch(): void {
    const activeFilter = this.filters.find(f => f.active);

    this.filterEvent.emit({code: activeFilter?.code || '', searchValue: this.searchValue});
  }

  cleanSearch(): void {
    this.searchValue = '';
    this.emitSearch();
  }

  handleSegmentedValueChange(value: string | number) {
    if (this.administrationUtilsService.syncingFromRoute) {
      return;
    }
    const pathMap: Record<string, string> = {
      'Ver órdenes': '/administration/service-orders',
      'Ver estados de pago': '/administration/invoice-orders',
      'Ver órdenes de compra': '/administration/purchase-orders',
      'Ver operaciones analíticas': '/administration/analytic-operations',
    };
    const targetPath = pathMap[String(value)] || '/administration/service-orders';
    const currentPath = this.router.url.split('?')[0];
    if (currentPath === targetPath) {
      return;
    }
    const view = value as 'Ver órdenes' | 'Ver estados de pago' | 'Ver órdenes de compra' | 'Ver operaciones analíticas';
    const targetPage = this.administrationUtilsService.getCurrentPageForSection(view);
    this.router.navigate([targetPath], {
      queryParams: { order: null, page: targetPage },
      queryParamsHandling: 'merge'
    }).then();
  }
}
